import { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { B, FONT } from '../../lib/constants';

export default function AddTaskModal({ projects, onClose, onSuccess, defaultProjectId }) {
  const [projectId, setProjectId] = useState(defaultProjectId || projects[0]?.id || '');
  const [text, setText] = useState('');
  const [priority, setPriority] = useState('medium');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!text.trim() || !projectId) return;
    setSaving(true);
    const { error } = await supabase.from('todos').insert({
      project_id: parseInt(projectId),
      text: text.trim(),
      priority,
    });
    setSaving(false);
    if (!error) {
      if (onSuccess) onSuccess();
      onClose();
    }
  };

  const inp = { background: B.mid, border: 'none', borderRadius: 8, padding: '10px 12px', color: B.white, fontSize: 14, outline: 'none', fontFamily: FONT, width: '100%', boxSizing: 'border-box', marginBottom: 12 };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500, padding: 20 }}>
      <div style={{ background: B.navy, borderRadius: 18, padding: 28, width: '100%', maxWidth: 440, border: `1px solid ${B.goldlt}` }}>
        <div style={{ color: B.goldlt, fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 16 }}>Add Task</div>

        <div style={{ color: B.muted, fontSize: 11, marginBottom: 8 }}>Select Build</div>
        <select value={projectId} onChange={e => setProjectId(e.target.value)} style={{ ...inp }}>
          {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>

        <input autoFocus placeholder="Task description…" value={text} onChange={e => setText(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
          style={inp} />

        <div style={{ color: B.muted, fontSize: 11, marginBottom: 8 }}>Priority</div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          {['high', 'medium', 'low'].map(p => (
            <button key={p} onClick={() => setPriority(p)}
              style={{ flex: 1, background: priority === p ? B.goldlt : B.slate, color: priority === p ? B.black : B.muted, border: 'none', borderRadius: 8, padding: '8px', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: FONT, textTransform: 'capitalize' }}>
              {p}
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={handleSave} disabled={saving || !text.trim()}
            style={{ flex: 1, background: B.goldlt, color: B.black, border: 'none', borderRadius: 10, padding: 12, cursor: 'pointer', fontSize: 14, fontWeight: 700, fontFamily: FONT, opacity: saving ? 0.6 : 1 }}>
            {saving ? 'Saving…' : 'Add Task'}
          </button>
          <button onClick={onClose}
            style={{ flex: 1, background: B.slate, color: B.white, border: 'none', borderRadius: 10, padding: 12, cursor: 'pointer', fontSize: 14, fontFamily: FONT }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
